<template lang="html">
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn color="red" v-on="on" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Decline Community</span>
      </v-card-title>
      <v-card-text>
        <v-textarea
          name="input-7-1"
          filled
          label="Reason for rejection"
          auto-grow
          v-model="reason"
        ></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
        <v-btn color="blue darken-1" text @click="closeDialogEmitEvent()">Decline</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CommunityDeclineDialog',
  props: ['el'],
  data: () => ({
    dialog: false,
    reason: ''
  }),
  methods: {
    closeDialogEmitEvent(){
      this.$emit('declineCommunityClick', {
        el: this.el,
        reason: this.reason
      });
      this.dialog = false;
    }
  }
}
</script>

<style lang="css" scoped>
</style>
